export default "__VITE_ASSET__MMW55t9z__"